import { CompareList } from '../../components/compare';
import { PageLayout } from '@/components/layout/PageLayout';
import { Button } from '@/components/ui/button';
import { ArrowLeftIcon, ArrowUpDown, BarChart3, Users } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';

export default function CompareCandidatesPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const order = (searchParams.get('order') as 'best' | 'worst') || 'best';

    const handleOrderChange = (newOrder: 'best' | 'worst') => {
        setSearchParams({ order: newOrder });
    };

    return (
        <PageLayout nav={true} footer={true}>
            <div className="min-h-screen bg-gradient-to-br from-background via-background to-accent/10">
                <div className="px-4 py-12 mx-auto max-w-7xl w-full">
                    {/* Header Section */}
                    <div className="mb-12">
                        <div className="flex items-center justify-between mb-6">
                            <div className="flex items-center gap-4">
                                <Link to="/app/positions">
                                    <Button variant="outline" size="sm" className="hover:bg-accent transition-colors">
                                        <ArrowLeftIcon className="h-4 w-4 mr-2" />
                                        Back to Positions
                                    </Button>
                                </Link>
                                <div className="h-8 w-px bg-border"></div>
                                <div className="flex items-center space-x-3">
                                    <div className="p-2 bg-primary/10 rounded-lg">
                                        <BarChart3 className="h-6 w-6 text-primary" />
                                    </div>
                                    <div>
                                        <h1 className="text-4xl font-bold tracking-tight bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
                                            Compare Candidates
                                        </h1>
                                        <p className="text-lg text-muted-foreground mt-1">
                                            Analyze and compare candidate performance across sessions
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center space-x-3">
                                <Button
                                    variant="outline"
                                    onClick={() => handleOrderChange(order === 'best' ? 'worst' : 'best')}
                                    className="hover:bg-accent hover:border-primary transition-all duration-200"
                                >
                                    <ArrowUpDown className="h-4 w-4 mr-2" />
                                    {order === 'best' ? 'Best First' : 'Worst First'}
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="space-y-8">
                        <CompareList />
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}
